import React, { createContext, type PropsWithChildren, useContext, useMemo } from "react";
import { type CdpIndustryConfig } from "./config";

type CdpIndustryContextType = {
  industry: CdpIndustryConfig;
};

const CdpIndustryContext = createContext<CdpIndustryContextType | undefined>(undefined);

export function CdpIndustryProvider({ industry, children }: PropsWithChildren<CdpIndustryContextType>) {
  const value = useMemo(() => ({ industry }), [industry]);

  return <CdpIndustryContext.Provider value={value}>{children}</CdpIndustryContext.Provider>;
}

export const useCdpIndustry = () => {
  const context = useContext(CdpIndustryContext);
  if (context === undefined) {
    throw new Error("useCdpIndustry must be used within a CdpIndustryProvider");
  }

  return context;
};
